import { render, staticRenderFns } from "./UploadFilesStepCardView.vue?vue&type=template&id=2095b7b6&scoped=true&"
import script from "./UploadFilesStepCardView.vue?vue&type=script&lang=js&"
export * from "./UploadFilesStepCardView.vue?vue&type=script&lang=js&"
import style0 from "./UploadFilesStepCardView.vue?vue&type=style&index=0&id=2095b7b6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2095b7b6",
  null
  
)

export default component.exports